import { Route } from "vue-router";
import { AuthenticatedService } from "../abstract/base.service";
import { ListRequest } from "@/models/grids/list.request";
import OrderBy from "@/models/shared/orderby";
import { ListResponse } from "@/models/grids/list.response";
import {
  CreateFeedbackCommand,
  EditFeedbackCommand,
} from "@/server/app.commands";
import { FeedbackDto, FeedbackStatsDto } from "@/server/app.dtos";
import {
  GetFeedbackDtosQuery,
  GetSingleFeedbackDtoQuery,
} from "@/server/app.queries";

export const FeedbacksEndpoint = `api/feedbacks`;
export const FeedbackQuestionsEndpoint = `api/feedbackquestions`;

export class FeedbacksRequestIncludes {
  parent: boolean = false;
}

export class FeedbacksListRequestFilter extends ListRequest {
  search?: string;
  name?: string;
  email?: string;
  idAppInterface?: number;
  orderBy?: string = "NameAsc";
  includes: FeedbacksRequestIncludes = new FeedbacksRequestIncludes();

  get GetOrderOptions(): OrderBy[] {
    return [
      new OrderBy("Nome Ascendente", "NameAsc"),
      new OrderBy("Nome Descendente", "NameDesc")
    ];
  }

  loadByRoute(route: Route) {
    if (route && route.query) {
      if (route.query.search) {
        this.search = route.query.search as string;
      }
      this.name = route.query.name ? (route.query.name as string) : undefined;
      this.email = route.query.email
        ? (route.query.email as string)
        : undefined;
      if (route.query.idAppInterface) {
        this.idAppInterface = parseInt(route.query.idAppInterface as string);
      }
      if (route.query.orderBy) {
        this.orderBy = route.query.orderBy as string;
      }
    }
  }
}

export class FeedbackService extends AuthenticatedService {
  GetList(request: GetFeedbackDtosQuery): Promise<ListResponse<FeedbackDto>> {
    return this.Get<ListResponse<FeedbackDto>>(
      `${this.baseUrl}${FeedbacksEndpoint}?${this.GetQueryStringByObject(request)}`
    );
  }

  GetSingle(request: GetSingleFeedbackDtoQuery): Promise<FeedbackDto> {
    return this.Get<FeedbackDto>(
      `${this.baseUrl}${FeedbacksEndpoint}/${
        request.idFeedback
      }?${this.GetQueryStringByObject(request)}`
    );
  }

  GetStats(id: number): Promise<FeedbackStatsDto>{
    return this.Get<FeedbackStatsDto>(
      `${this.baseUrl}${FeedbacksEndpoint}/${id}/stats`
    );
  }

  Create(entity: CreateFeedbackCommand): Promise<number> {
    return this.Post<number>(`${this.baseUrl}${FeedbacksEndpoint}`, entity);
  }

  Edit(command: EditFeedbackCommand): Promise<number> {
    return this.Put<number>(
      `${this.baseUrl}${FeedbacksEndpoint}/${command.idFeedback}`,
      command
    );
  }

  DeleteById(id: number): Promise<number> {
    return this.Delete(`${this.baseUrl}${FeedbacksEndpoint}/${id}`);
  }

  DeleteFeedbackVsUser(idFeedback: number, idUser: number): Promise<number> {
    return this.Delete(
      `${this.baseUrl}${FeedbacksEndpoint}/${idFeedback}/deletefeedbackvsuser/${idUser}`
    );
  }

}
